import { Outlet } from 'react-router';
import { urlLanguageCheckMiddleware } from '~/shell/middleware/urlLanguageCheckMiddleware.ts';

export const middleware = [urlLanguageCheckMiddleware];

/**
 * The language content layout for the application.
 * Currently only renders the outlet and makes sure that the default error boundary is used inside the common layout.
 */
export default function LanguageContentLayoutRoute() {
  return <Outlet />;
}
